module.exports = __webpack_public_path__ + "img/bgi.c08d86b9.png";